import React, { useState } from 'react';
import Button from '@components/Button';
import {
  CompleteCard,
  ScormContentWrapper,
  ScormTitle,
  ScormDescription,
  StartLink,
  ScoreDisplay,
  ScoreCircle,
  ScorePercentage,
  ScormButtonWrapper,
} from './style';
import Tick from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Check';
import { getIdsFromRedoUrl, getUnitContent } from './helpers';
import { FormattedMessage } from 'react-intl';
import CardInfoModal from './CardInfoModal';
import { REDO_SCORM } from '@mutations/redoScorm';
import { useMutation } from '@apollo/react-hooks';

const Complete = ({ unit }: { unit: any }) => {
  const { title, description, redoUrl, startUrl } = getUnitContent(unit);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [redoScorm, { loading: redoLoading }] = useMutation(REDO_SCORM);
  const isDisabled = !redoUrl;

  const handleRedo = async () => {
    if (!redoUrl || !startUrl) return;
    const { userId, scormId } = getIdsFromRedoUrl(redoUrl);
    if (!userId || !scormId) return;
    try {
      await redoScorm({
        variables: { userId, scormId },
      });
      window.open(startUrl, "_blank", "noopener,noreferrer");
    } catch (e) {
      console.error('Redo error:', e);
    }
  };

  return (
    <CompleteCard>
      <ScormContentWrapper>
        <ScormTitle>{title}</ScormTitle>
        <ScormDescription>{description}</ScormDescription>

        <StartLink onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer' }}>
          What is an e-learning module?
        </StartLink>

        <ScoreDisplay>
          <ScorePercentage>
            <FormattedMessage id="Completed" />
          </ScorePercentage>
          <ScoreCircle>
            <Tick color="white" size="xs" />
          </ScoreCircle>
        </ScoreDisplay>

        <ScormButtonWrapper>
          <Button
            color="brandPrimary"
            fullWidth
            onClick={handleRedo}
            disabled={isDisabled || redoLoading}
          >
            <FormattedMessage id="Redo" />
          </Button>
        </ScormButtonWrapper>
      </ScormContentWrapper>

      <CardInfoModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </CompleteCard>
  );
};

export default Complete;